import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { DIVIDER_TYPE } from '../defaults.js';
import { w as withSafariSvgCaretFixer } from '../withSafariSvgCaretFixer-04d64192.js';
import 'wix-rich-content-common';
import '../style-inject.es-746bb8ed.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const lineProps = (width, lineDistance = 1) => ({
  x2: width,
  y1: lineDistance,
  y2: lineDistance
});
const getLines = (type, width, multilineDistance = 7) => {
  const linePropsArr = [lineProps(width)];
  if (type === DIVIDER_TYPE.LINE_DOUBLE) {
    linePropsArr.push(lineProps(width, multilineDistance));
  }
  return linePropsArr;
};
const DividerLine = ({
  type,
  size,
  alignment,
  width,
  multilineDistance,
  styles,
  className,
  fillParent,
  isMobile
}) => {
  const linesPropsArr = getLines(type, width, multilineDistance);
  const lineClassName = classNames(
    styles.divider,
    styles[`divider--${type}`],
    styles[`divider--${size}${isMobile ? "--mobile" : ""}`],
    styles[`divider--${alignment}`],
    fillParent ? styles["divider--fill-parent"] : "",
    className
  );
  return withSafariSvgCaretFixer(
    /* @__PURE__ */ React.createElement("svg", { className: lineClassName }, linesPropsArr.map((lineProp, i) => /* @__PURE__ */ React.createElement("line", __spreadValues({ key: i }, lineProp))))
  );
};
DividerLine.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.string,
  alignment: PropTypes.string,
  styles: PropTypes.object.isRequired,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  multilineDistance: PropTypes.number,
  fillParent: PropTypes.bool,
  isMobile: PropTypes.bool
};

export { DividerLine as default };
//# sourceMappingURL=divider-line.js.map
